var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 3.765 15.232"}},[_c('path',{staticClass:"a",attrs:{"fill":"#e50027","d":"M1.883 12.123a1.122 1.122 0 001.118-1.028l.758-9.055a1.882 1.882 0 10-3.752 0l.758 9.055a1.122 1.122 0 001.118 1.028zM1.883 12.789a1.222 1.222 0 101.222 1.222 1.222 1.222 0 00-1.222-1.222z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }